import { render, staticRenderFns } from "./meterialtypes.vue?vue&type=template&id=01f87f42&"
import script from "./meterialtypes.vue?vue&type=script&lang=js&"
export * from "./meterialtypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports